export const module_names = {
  home_module: "Home",
  account_module: "Accounts",
  user_module: "User",
  site_module: "Site",
  job_module: "Job",
  poster_module: "Poster",
  proofcard_module: "Proofcard",
  voucher_module: "Voucher",
  banner_module: "Banner",
  template_module: "Template",
  categories_module: "Categories",
  product_module: "Product",
  newsletter_module: "NewsLetter",
  order_module: "Order",
  pages_module: "StaticPages",
  portfolio_module: "Portfolio",
  role_module: "Role",
  sizeorder_module: "SizeOrdering",
  subscriber_module: "Subscriber",
  productmanager_module: "ProductManager",
  welcomepage_module: "WelcomePage",
  parentfaqspage_module: "ParentFaqsPage",
  nurseryfaqspage_module: "NurseryFaqsPage",
  proofcardVsaccount_module: "ProofcardVSAccount",
  gdprPolicy_module: "GDPRPolicy",
  nurserymanager_module: "NurseryManager",
  vacanciespage_module: "VacanciesPage",
  termsncondition_module: "TermsNConditionPage",
  orderpage_module: "Orderpage",
  comissionpage_module: "CommisionPage",
  classnteampic_module: "ClassNTeamPicturePage",
  howwework_module: "HowWeWorkPage",
  whatarecookie_module: "WhatAreCookiesPage",
  nurserynschool_module: "NurseryNSchoolPage",
  oldergrouppage_module: "OlderGroupPage",
  footerpage_module: "FooterPage",
  paymentsetting_module: "PaymentSetting",
  ftpDropZone_module: "FTPDropZone",
  OrderStatus_module: "OrderStatus",
  SearchOrderStatus_module: "SearchOrderStatus",
  CreateEditOrder: "Create/EditOrders",
  OlderOrders_module: "OlderOrders",
  OlderSearchOrders_module: "OlderSearchOrders",
  promotionalSubscriber_module: "PromotionalSubscribers",
  gdprLog_module: "GdprLog",
  customers_module: "Customers",
  proofcardlisting_module: "CustomerProofcards",
  productExport_module: "ProductExport",
  commissiontemplate_module: "Commission",
  bookingform_module: "BookingForm",
  bookingcalender_module: "BookingCalender",
  bulkuploder_module: "BulkUploder",
  SiteGroup_module: "SiteGroup",
  ho_bookingcalender_module: "HoBookingCalender",
  ho_orderstats_module: "HoOrderStats",

};
